{
  "crm.unassigned": "Unassigned",
  "crm.unknown_person": "Unknown colleague",
  "crm.undo": "Undo",
  "crm.clear_filters": "Clear filters",
  "crm.assigned_to": "Assigned to {name}",
  "crm.retry": "Retry",
  "crm.refresh": "Refresh",
  "crm.timezone_hint": "Office time ({zone})",
  "crm.readonly_title": "View only",
  "crm.readonly_body": "Your role lets you view contacts, enquiries and tasks, but not change them.",

  "crm.channel.unknown": "Unknown source",
  "crm.channel.with_detail": "{channel}: {detail}",
  "crm.channel.website": "Website",
  "crm.channel.portal": "Portal",
  "crm.channel.email": "Email",
  "crm.channel.phone": "Phone",
  "crm.channel.manual": "Added by hand",
  "crm.channel.import": "Import",
  "crm.channel.seed": "Demo data",

  "crm.due.today": "Today {time}",
  "crm.due.tomorrow": "Tomorrow {time}",
  "crm.due.yesterday": "Yesterday {time}",

  "crm.field.name": "Name",
  "crm.field.email": "Email",
  "crm.field.phone": "Phone",
  "crm.field.language": "Language",
  "crm.field.country": "Country",
  "crm.field.source": "Source",
  "crm.field.owner": "Handled by",
  "crm.field.created": "Added",
  "crm.field.retention": "Keep until",
  "crm.field.reference": "Reference for the client",

  "crm.leads.title": "Enquiries",
  "crm.leads.count": "{count, plural, one {# enquiry} other {# enquiries}}",
  "crm.leads.search_label": "Search enquiries",
  "crm.leads.search_placeholder": "Name, email, property or reference",
  "crm.leads.status_open": "All except spam",
  "crm.leads.col_lead": "Enquiry",
  "crm.leads.col_message": "Message",
  "crm.leads.col_received": "Received",
  "crm.leads.col_assignee": "Handled by",
  "crm.leads.col_status": "Status",
  "crm.leads.unknown_sender": "Unknown sender",
  "crm.leads.empty_title": "No enquiries yet",
  "crm.leads.empty_body": "Enquiries from your website and portals arrive here.",
  "crm.leads.empty_filtered_title": "No enquiries match these filters",
  "crm.leads.empty_filtered_body": "Change the filters or clear them to see all enquiries.",
  "crm.leads.scope_label": "Whose",
  "crm.leads.scope_all": "Everyone",
  "crm.leads.scope_mine": "Mine",
  "crm.leads.signal_overdue": "Response deadline passed ({when})",
  "crm.leads.signal_soon": "Reply before {when}",
  "crm.leads.signal_spam": "Possible spam: {reasons}",
  "crm.leads.empty_action": "Go to the website",
  "crm.leads.empty_mine_title": "Nothing assigned to you",
  "crm.leads.empty_mine_body": "New enquiries for you appear here.",
  "crm.leads.show_everyone": "View all enquiries",
  "crm.leads.bulk_label": "Actions for the selection",
  "crm.leads.bulk_assign": "Assign",
  "crm.leads.bulk_status": "Status",
  "crm.leads.bulk_other": "Other",
  "crm.leads.assign_me": "To me",
  "crm.leads.bulk_done": "{count, plural, one {# enquiry updated} other {# enquiries updated}}",
  "crm.leads.bulk_failed": "{count, plural, one {# enquiry not updated} other {# enquiries not updated}}",

  "crm.lead.title": "Enquiry",
  "crm.lead.received_at": "received {date}",
  "crm.lead.not_found_title": "Enquiry not found",
  "crm.lead.not_found_body": "This enquiry no longer exists or belongs to another organisation.",
  "crm.lead.field_status": "Status",
  "crm.lead.field_assignee": "Assigned to",
  "crm.lead.status_changed": "Status changed to {status}",
  "crm.lead.assigned": "Assigned to {name}",
  "crm.lead.unassigned_done": "Assignment removed",
  "crm.lead.mark_spam": "Mark as spam",
  "crm.lead.marked_spam": "Marked as spam",
  "crm.lead.not_spam": "Not spam, restore",
  "crm.lead.restored": "Enquiry restored to the inbox",
  "crm.lead.mark_contacted": "Record first contact",
  "crm.lead.contacted_done": "First contact recorded",
  "crm.lead.spam_title": "Marked as spam",
  "crm.lead.spam_body": "This enquiry is hidden from the regular inbox. Restore it if it is a genuine question.",
  "crm.lead.suspect_title": "Possibly spam",
  "crm.lead.signal.honeypot": "hidden field filled in",
  "crm.lead.signal.tooFast": "form sent within a few seconds",
  "crm.lead.signal.linkHeavy": "many links in the message",
  "crm.lead.overdue_title": "Reply deadline passed",
  "crm.lead.overdue_body": "The reply was due by {deadline}. Record the contact as soon as you have replied.",
  "crm.lead.preferred_times": "Preferred viewing times:",
  "crm.lead.seller_locality": "Town",
  "crm.lead.seller_kind": "Property type",
  "crm.lead.seller_price": "Asking price (as given)",
  "crm.lead.seller_timeline": "Wants to sell",
  "crm.lead.contact": "Contact details",
  "crm.lead.open_dossier": "Open contact file",
  "crm.lead.property_unlinked": "Reference {ref} was given but is not linked to a property in BRES.",
  "crm.lead.follow_up": "Follow-up",
  "crm.lead.notes": "Notes",
  "crm.lead.consents": "Consents",
  "crm.lead.history": "History",
  "crm.lead.back_to_list": "Back to the list",
  "crm.lead.status_failed": "Couldn't change the status",
  "crm.lead.assign_failed": "Couldn't assign the enquiry",
  "crm.lead.soon_title": "Response deadline is close",
  "crm.lead.soon_body": "Reply before {deadline}.",
  "crm.lead.no_follow_up": "No task or appointment yet.",

  "crm.seller.timeline.now": "As soon as possible",
  "crm.seller.timeline.3_months": "Within 3 months",
  "crm.seller.timeline.6_months": "Within 6 months",
  "crm.seller.timeline.exploring": "Exploring options",

  "crm.history.received": "Enquiry received via {source}",
  "crm.history.first_response": "First reply recorded",
  "crm.history.status": "Status changed to {status}",
  "crm.history.assigned": "Assigned to {name}",
  "crm.history.unassigned": "Assignment removed",
  "crm.history.task_created": "Task created: {title}",
  "crm.history.task_done": "Task completed: {title}",
  "crm.history.appointment_confirmed": "Appointment recorded",
  "crm.history.appointment_request": "Appointment request recorded",
  "crm.history.notifications": "Notifications",
  "crm.history.received_spam": "Enquiry received via {source}, flagged as possible spam",
  "crm.history.notifications_queued": "{count, plural, one {# notification queued} other {# notifications queued}}",

  "crm.notification.pending": "Notification waiting to be sent",
  "crm.notification.failed": "{count, plural, one {Sending failed after # attempt} other {Sending failed after # attempts}}",
  "crm.notification.dead": "Notification not sent",
  "crm.notification.state.pending": "Queued",
  "crm.notification.state.failed": "Retrying",
  "crm.notification.state.dead": "Stopped",

  "crm.contacts.title": "Contacts",
  "crm.contacts.count": "{count, plural, one {# contact} other {# contacts}}",
  "crm.contacts.new": "Add contact",
  "crm.contacts.search_label": "Search contacts",
  "crm.contacts.search_placeholder": "Name or email address",
  "crm.contacts.col_name": "Name",
  "crm.contacts.col_source": "Source",
  "crm.contacts.no_details": "No email or phone",
  "crm.contacts.leads_count": "{count, plural, one {# enquiry} other {# enquiries}}",
  "crm.contacts.briefs_count": "{count, plural, one {# active search profile} other {# active search profiles}}",
  "crm.contacts.empty_title": "No contacts yet",
  "crm.contacts.empty_body": "Every enquiry creates a contact automatically. You can also add someone yourself.",
  "crm.contacts.empty_filtered_title": "Nobody found",
  "crm.contacts.empty_filtered_body": "No contact with \"{q}\" in their name or email address.",
  "crm.contacts.new_title": "Add contact",
  "crm.contacts.create": "Save contact",
  "crm.contacts.created": "{name} added",
  "crm.contacts.possible_duplicate": "Note: {name} has the same email address. Check whether this is the same person.",
  "crm.contacts.locale_unknown": "Unknown",
  "crm.contacts.country_hint": "Two-letter country code, for example NL or GB",
  "crm.contacts.country_invalid": "Use two letters, for example GB",
  "crm.contacts.email_invalid": "Enter a valid email address",
  "crm.contacts.roles_required": "Choose at least one role",
  "crm.contacts.count_capped": "{count}+ contacts",
  "crm.contacts.col_role": "Role",
  "crm.contacts.col_activity": "Activity",
  "crm.contacts.col_owner": "Handled by",
  "crm.contacts.col_last": "Last active",
  "crm.contacts.field_roles": "Roles",

  "crm.contact_role.buyer": "Buyer",
  "crm.contact_role.tenant": "Tenant",
  "crm.contact_role.owner": "Owner",
  "crm.contact_role.seller": "Seller",
  "crm.contact_role.partner": "Partner",

  "crm.contact.title": "Contact",
  "crm.contact.not_found_title": "Contact not found",
  "crm.contact.not_found_body": "This contact no longer exists or belongs to another organisation.",
  "crm.contact.back_to_list": "Go to all contacts",
  "crm.contact.details": "Details",
  "crm.contact.consents": "Consents",
  "crm.contact.sections": "Sections of the contact file",
  "crm.contact.leads": "Enquiries",
  "crm.contact.follow_up": "Follow-up",
  "crm.contact.briefs": "Search profiles",
  "crm.contact.shortlists": "Selections",
  "crm.contact.no_leads_title": "No enquiries",
  "crm.contact.no_leads_body": "This contact has not sent an enquiry through the website or a portal yet.",
  "crm.contact.open_tasks": "Open tasks",
  "crm.contact.closed_tasks": "Completed and cancelled",
  "crm.contact.appointments": "Appointments",
  "crm.contact.no_appointments": "No appointments yet.",
  "crm.contact.timeline": "Timeline",
  "crm.contact.no_tasks": "No open tasks.",

  "crm.tasks.title": "Tasks",
  "crm.tasks.count": "{count, plural, one {# open task} other {# open tasks}}",
  "crm.tasks.new": "Create task",
  "crm.tasks.view_label": "Which tasks",
  "crm.tasks.view_mine": "My tasks",
  "crm.tasks.view_all": "All tasks",
  "crm.tasks.bucket.overdue": "Overdue",
  "crm.tasks.bucket.today": "Today",
  "crm.tasks.bucket.later": "Later",
  "crm.tasks.bucket.none": "No date",
  "crm.tasks.complete_label": "Complete: {title}",
  "crm.tasks.actions_for": "Actions for {title}",
  "crm.tasks.edit": "Edit",
  "crm.tasks.cancel_task": "Cancel task",
  "crm.tasks.completed": "Task completed",
  "crm.tasks.cancelled": "Task cancelled",
  "crm.tasks.reopened": "Task reopened",
  "crm.tasks.saved": "Task saved",
  "crm.tasks.edit_title": "Edit task",
  "crm.tasks.save": "Save changes",
  "crm.tasks.new_title": "Create task",
  "crm.tasks.new_for_lead": "For the enquiry from {name}",
  "crm.tasks.new_for_contact": "For {name}",
  "crm.tasks.create": "Create task",
  "crm.tasks.created": "Task created",
  "crm.tasks.field_title": "What needs to happen?",
  "crm.tasks.field_kind": "Type",
  "crm.tasks.field_priority": "Priority",
  "crm.tasks.field_due": "Deadline",
  "crm.tasks.field_assignee": "Assigned to",
  "crm.tasks.field_contact": "Contact",
  "crm.tasks.field_contact_placeholder": "Search by name",
  "crm.tasks.default_title_lead": "Reply to the enquiry from {name}",
  "crm.tasks.default_title_contact": "Get in touch with {name}",
  "crm.tasks.empty_mine_title": "No open tasks for you",
  "crm.tasks.empty_mine_body": "New enquiries create a task automatically. You can also create one yourself.",
  "crm.tasks.empty_mine_body_readonly": "Tasks assigned to you appear here.",
  "crm.tasks.empty_all_title": "No open tasks",
  "crm.tasks.empty_all_body": "Nobody in your team has open tasks.",
  "crm.tasks.show_all": "View all tasks",
  "crm.tasks.search_label": "Search tasks",
  "crm.tasks.search_placeholder": "Task or contact",
  "crm.tasks.priority_high": "High priority",
  "crm.tasks.reopen_label": "Reopen: {title}",
  "crm.tasks.done_ago": "Completed {when}",
  "crm.tasks.state_cancelled": "Cancelled",
  "crm.tasks.complete_failed": "Couldn't complete the task",
  "crm.tasks.save_failed": "Couldn't save the task",
  "crm.tasks.empty_search_title": "No tasks found",
  "crm.tasks.empty_search_body": "No open task with these words in the title or contact.",

  "crm.task.kind.follow_up": "Follow up",
  "crm.task.kind.call": "Call",
  "crm.task.kind.viewing": "Viewing",
  "crm.task.kind.document": "Document",
  "crm.task.kind.review": "Check",
  "crm.task.kind.mandate": "Sales mandate",
  "crm.task.kind.other": "Other",

  "crm.related.contact": "Contact",
  "crm.related.lead": "Enquiry",
  "crm.related.property": "Property",
  "crm.related.appointment": "Appointment",
  "crm.related.import_run": "Import",
  "crm.related.localized_revision": "Translation",

  "crm.appointments.new": "Plan appointment",
  "crm.appointments.new_title": "Plan appointment",
  "crm.appointments.field_kind": "Type of appointment",
  "crm.appointments.kind_confirmed_hint": "Time and staff member are fixed",
  "crm.appointments.kind_request_hint": "Time still to be agreed",
  "crm.appointments.field_property": "Property",
  "crm.appointments.no_property": "No property",
  "crm.appointments.field_start": "Starts at",
  "crm.appointments.field_duration": "Duration",
  "crm.appointments.minutes": "{count, plural, one {# minute} other {# minutes}}",
  "crm.appointments.field_staff": "Staff member",
  "crm.appointments.submit_confirmed": "Record appointment",
  "crm.appointments.submit_request": "Record request",
  "crm.appointments.created_confirmed": "Appointment recorded",
  "crm.appointments.created_request": "Appointment request recorded",
  "crm.appointments.range": "{start} to {end}",
  "crm.appointments.preferred": "Preference: {slots}",
  "crm.appointments.no_time": "No time yet",

  "crm.appointment.kind.confirmed": "Confirmed appointment",
  "crm.appointment.kind.request": "Appointment request",
  "crm.appointment.status.requested": "Requested",
  "crm.appointment.status.confirmed": "Confirmed",
  "crm.appointment.status.completed": "Completed",
  "crm.appointment.status.cancelled": "Cancelled",
  "crm.appointment.status.no_show": "No-show",

  "crm.notes.field": "New note",
  "crm.notes.placeholder": "Only visible to your team",
  "crm.notes.save": "Save note",
  "crm.notes.saved": "Note saved",
  "crm.notes.none": "No notes yet.",
  "crm.notes.save_failed": "Couldn't save the note",

  "crm.consent.service": "Contact about the enquiry",
  "crm.consent.marketing_email": "News and listings by email",
  "crm.consent.property_alerts": "Alerts for new properties",
  "crm.consent.none": "No consents recorded.",
  "crm.consent.recorded_on": "Recorded on {date}",
  "crm.consent.withdrawn_on": "Withdrawn on {date}",
  "crm.consent.times": "{count, plural, one {recorded # time} other {recorded # times}}",
  "crm.consent.state_granted": "Given",
  "crm.consent.state_refused": "Refused",
  "crm.consent.state_withdrawn": "Withdrawn",

  "crm.briefs.new": "Record search profile",
  "crm.briefs.new_title": "Record search profile",
  "crm.briefs.new_body": "Requirements rule properties out. Nice-to-haves only affect the order.",
  "crm.briefs.create": "Save search profile",
  "crm.briefs.created": "Search profile recorded",
  "crm.briefs.field_offer": "Looking for",
  "crm.briefs.field_budget_min": "Budget from",
  "crm.briefs.field_budget_max": "Budget up to",
  "crm.briefs.budget_invalid": "Must be at least the minimum budget",
  "crm.briefs.field_areas": "Areas",
  "crm.briefs.field_areas_hint": "A region includes all towns within it. Nothing selected means anywhere.",
  "crm.briefs.field_kinds": "Property types",
  "crm.briefs.field_kinds_hint": "Nothing selected means any type.",
  "crm.briefs.field_bedrooms": "Minimum bedrooms",
  "crm.briefs.field_bathrooms": "Minimum bathrooms",
  "crm.briefs.field_built": "Minimum living area",
  "crm.briefs.field_must": "Requirements",
  "crm.briefs.field_must_hint": "Properties without these features are ruled out.",
  "crm.briefs.field_nice": "Nice to have",
  "crm.briefs.field_nice_hint": "Count towards the order but rule nothing out.",
  "crm.briefs.field_notes": "Notes",
  "crm.briefs.budget": "Budget",
  "crm.briefs.budget_range": "{min} to {max}",
  "crm.briefs.budget_max": "Up to {max}",
  "crm.briefs.budget_min": "From {min}",
  "crm.briefs.budget_none": "No budget given",
  "crm.briefs.minimum": "Minimum",
  "crm.briefs.min_bedrooms": "{count, plural, one {# bedroom} other {# bedrooms}}",
  "crm.briefs.min_bathrooms": "{count, plural, one {# bathroom} other {# bathrooms}}",
  "crm.briefs.any": "No preference",
  "crm.briefs.unknown_area": "Unknown area",
  "crm.briefs.empty_title": "No search profile yet",
  "crm.briefs.empty_body": "Record what this contact is looking for. You will then see which properties match and why.",
  "crm.briefs.recorded": "Recorded",

  "crm.brief.status.active": "Active",
  "crm.brief.status.paused": "Paused",
  "crm.brief.status.closed": "Closed",

  "crm.matches.show": "Show matching properties",
  "crm.matches.hide": "Hide matching properties",
  "crm.matches.summary": "{count, plural, =0 {None of the {evaluated} properties checked match} one {# of {evaluated} properties checked matches} other {# of {evaluated} properties checked match}}",
  "crm.matches.list_label": "Matching properties",
  "crm.matches.why": "{met} of {total} criteria",
  "crm.matches.untitled": "No title yet",
  "crm.matches.price_on_request": "Price on request",
  "crm.matches.not_on_website": "Not on the website",
  "crm.matches.select_label": "Add {ref} to the selection",
  "crm.matches.selected": "{count, plural, =0 {Nothing selected} one {# property selected} other {# properties selected}}",
  "crm.matches.select_all": "Select all",
  "crm.matches.empty_title": "No matching properties",
  "crm.matches.empty_body": "No available property meets all requirements. Widen the budget, the area or the required features.",

  "crm.match.status_met": "Available",
  "crm.match.status_other": "Status: {status}",
  "crm.match.budget_met": "Within budget",
  "crm.match.budget_unknown": "Price on request",
  "crm.match.budget_currency": "Priced in {currency}",
  "crm.match.area_met": "In a chosen area",
  "crm.match.area_unknown": "Area unknown",
  "crm.match.kind_met": "Chosen type",
  "crm.match.bedrooms_met": "{count, plural, one {# bedroom} other {# bedrooms}} (min. {wanted})",
  "crm.match.bedrooms_unknown": "Bedrooms unknown",
  "crm.match.bathrooms_met": "{count, plural, one {# bathroom} other {# bathrooms}} (min. {wanted})",
  "crm.match.bathrooms_unknown": "Bathrooms unknown",
  "crm.match.built_met": "{actual} m² (min. {wanted} m²)",
  "crm.match.built_unknown": "Living area unknown",
  "crm.match.must_met": "Has {feature}",
  "crm.match.nice_met": "Plus: {feature}",
  "crm.match.nice_missing": "Missing: {feature}",
  "crm.match.offer_other": "Different type of offer",

  "crm.shortlists.create_from": "{count, plural, =0 {Create selection} one {Create selection with # property} other {Create selection with # properties}}",
  "crm.shortlists.new_title": "Create selection",
  "crm.shortlists.new_body": "{count, plural, one {# property goes into this selection.} other {# properties go into this selection.}}",
  "crm.shortlists.field_title": "Name of the selection",
  "crm.shortlists.default_title": "Selection for {name}, {date}",
  "crm.shortlists.properties": "Properties",
  "crm.shortlists.create": "Save selection",
  "crm.shortlists.created": "{count, plural, one {Selection with # property saved} other {Selection with # properties saved}}",
  "crm.shortlists.items": "{count, plural, one {# property} other {# properties}}",
  "crm.shortlists.empty_title": "No selections yet",
  "crm.shortlists.empty_body": "Create a selection from the matching properties of a search profile and share it with a link.",
  "crm.shortlists.go_to_briefs": "Go to search profiles",
  "crm.shortlists.made": "Created",

  "crm.shares.new": "Create share link",
  "crm.shares.new_title": "Create share link",
  "crm.shares.field_locale": "Page language",
  "crm.shares.field_locale_hint": "Only languages that are live on the website.",
  "crm.shares.field_days": "Valid for (days)",
  "crm.shares.field_days_hint": "Expires on {date}",
  "crm.shares.field_days_range": "Choose between 1 and 90 days",
  "crm.shares.create": "Create share link",
  "crm.shares.ready_title": "Share link ready",
  "crm.shares.once_title": "Copy the link now",
  "crm.shares.once_body": "BRES only keeps a check code, not the link itself. Once you close this window you cannot see it again; create a new one instead.",
  "crm.shares.url_label": "Share link",
  "crm.shares.copy": "Copy link",
  "crm.shares.copied": "Link copied",
  "crm.shares.copy_failed": "Copying did not work. Select the link and copy it yourself.",
  "crm.shares.done": "Done",
  "crm.shares.close_without_copy": "Close without copying",
  "crm.shares.expires_on": "Expires on {date}",
  "crm.shares.expired_on": "Expired on {date}",
  "crm.shares.revoked_on": "Revoked on {date}",
  "crm.shares.views": "{count, plural, =0 {Not viewed yet} one {Viewed # time} other {Viewed # times}}",
  "crm.shares.link_in": "Link in {language}",
  "crm.shares.revoke": "Revoke",
  "crm.shares.revoke_title": "Revoke share link?",
  "crm.shares.revoke_body": "Anyone with the link in {language} can no longer open the selection. This cannot be undone.",
  "crm.shares.revoke_confirm": "Revoke share link",
  "crm.shares.revoked": "Share link revoked",
  "crm.shares.title": "Share links",
  "crm.shares.revoke_failed": "Couldn't revoke the link",

  "crm.feature.private_pool": "Private pool",
  "crm.feature.communal_pool": "Communal pool",
  "crm.feature.garden": "Garden",
  "crm.feature.terrace": "Terrace",
  "crm.feature.balcony": "Balcony",
  "crm.feature.roof_terrace": "Roof terrace",
  "crm.feature.garage": "Garage",
  "crm.feature.parking": "Parking space",
  "crm.feature.storage_room": "Storage room",
  "crm.feature.lift": "Lift",
  "crm.feature.air_conditioning": "Air conditioning",
  "crm.feature.heating": "Heating",
  "crm.feature.solar_panels": "Solar panels",
  "crm.feature.fireplace": "Fireplace",
  "crm.feature.fitted_kitchen": "Fitted kitchen",
  "crm.feature.furnished": "Furnished",
  "crm.feature.barbecue": "Barbecue",
  "crm.feature.gated_community": "Gated community",
  "crm.feature.sea_front": "Seafront",
  "crm.feature.near_beach": "Near the beach",
  "crm.feature.near_golf": "Near a golf course",
  "crm.feature.wheelchair_accessible": "Wheelchair accessible",
  "crm.feature.fibre_internet": "Fibre internet",
  "crm.feature.water_deposit": "Water tank",
  "crm.feature.guest_apartment": "Guest apartment",
  "crm.feature.tourist_license": "Tourist licence",


  "crm.timeline.lead": "{kind} via {source}",
  "crm.timeline.note": "Note by {name}",
  "crm.timeline.brief": "Search profile recorded: {offer}",
  "crm.timeline.shortlist": "Selection created: {title}",
  "crm.timeline.consent_granted": "Consent given: {purpose}",
  "crm.timeline.consent_refused": "Consent refused: {purpose}",
  "crm.timeline.consent_withdrawn": "Consent withdrawn: {purpose}",
  "crm.timeline.created": "Contact added"
}
